import { PATH_DASHBOARD } from 'routes/paths'

import { PondTab } from '../constants'

export interface PondMenuItem {
  icon(speciesId?: number): string
  label: string
  permission: PondTab
  path: (farmId: string, pondId: string) => string
  hasChevron?: boolean
}

export const POND_MENU_ITEMS: PondMenuItem[] = [
  {
    icon: () => '/static/icons/layout/overview.svg',
    label: 'overview',
    permission: PondTab.Dashboard,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.dashboard(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/food.svg',
    label: 'food',
    permission: PondTab.Food,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.food(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/growth.svg',
    label: 'growth',
    permission: PondTab.Growth,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.growth(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/water-quality.svg',
    label: 'waterQuality',
    permission: PondTab.Water,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.water(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/shrimp-die.svg',
    label: 'shrimpDie',
    permission: PondTab.DeadShrimp,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.deadShrimp(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/medicine.svg',
    label: 'medicine',
    permission: PondTab.Medicine,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.medicine(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/growth.svg',
    label: 'cost',
    permission: PondTab.Cost,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.cost(farmId, pondId),
  },
  {
    icon: (speciesId) =>
      speciesId === 2
        ? '/static/icons/layout/sell-fish.svg'
        : '/static/icons/layout/sell-shrimp.svg',
    label: 'sellShrimp',
    permission: PondTab.Sales,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.sales(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/transfer-shrimp.svg',
    label: 'transferShrimp',
    permission: PondTab.Transfer,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.transfer(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/topup-shrimp.svg',
    label: 'topupShrimp',
    permission: PondTab.Topup,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.topup(farmId, pondId),
  },
  {
    icon: () => '/static/icons/layout/setting.svg',
    label: 'setting',
    permission: PondTab.Setting,
    path: (farmId, pondId) => PATH_DASHBOARD.ponds.setting(farmId, pondId),
  },
]
